import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { MdMenuBook } from "react-icons/md";
import { RiDashboard3Line } from "react-icons/ri";
import { CiBoxList } from "react-icons/ci";
import { GiAlarmClock } from "react-icons/gi";
import { LuVariable } from "react-icons/lu";
import { FaDatabase, FaAngleLeft, FaAngleRight, FaQuestionCircle } from "react-icons/fa";
import { AiOutlineSetting } from "react-icons/ai";

// Menu items component for reuse
export function MenuItems({ user, collapsed }) {
  return (
    <>
      <li className="nav-item">
        <NavLink to="/dashboard" className="nav-link" title={collapsed ? "Dashboard" : ""} data-tour="menu-dashboard">
          <RiDashboard3Line className={collapsed ? "" : "me-2"} />
          <span className="menu-text">Dashboard</span>
        </NavLink>
      </li>
      <li>
        {user?.clientId ? (
          <NavLink to="/runbook" className="nav-link" title={collapsed ? "My Runbooks" : ""} data-tour="menu-runbooks">
            <CiBoxList className={collapsed ? "" : "me-2"} />
            <span className="menu-text">My Runbooks</span>
          </NavLink>
        ) : (
          <span className="nav-link disabled" style={{ opacity: 0.4, cursor: "not-allowed", color: "rgba(255,255,255,0.5)" }} title="Select a client first" data-tour="menu-runbooks">
            <CiBoxList className={collapsed ? "" : "me-2"} />
            <span className="menu-text">My Runbooks</span>
          </span>
        )}
      </li>
      <li>
        {user?.clientId ? (
          <NavLink to="/scheduler" className="nav-link" title={collapsed ? "My Schedulers" : ""} data-tour="menu-schedulers">
            <GiAlarmClock className={collapsed ? "" : "me-2"} />
            <span className="menu-text">My Schedulers</span>
          </NavLink>
        ) : (
          <span className="nav-link disabled" style={{ opacity: 0.4, cursor: "not-allowed", color: "rgba(255,255,255,0.5)" }} title="Select a client first" data-tour="menu-schedulers">
            <GiAlarmClock className={collapsed ? "" : "me-2"} />
            <span className="menu-text">My Schedulers</span>
          </span>
        )}
      </li>
      <li>
        {user?.clientId ? (
          <NavLink to="/variable" className="nav-link" title={collapsed ? "My Variables" : ""} data-tour="menu-variables">
            <LuVariable className={collapsed ? "" : "me-2"} />
            <span className="menu-text">My Variables</span>
          </NavLink>
        ) : (
          <span className="nav-link disabled" style={{ opacity: 0.4, cursor: "not-allowed", color: "rgba(255,255,255,0.5)" }} title="Select a client first" data-tour="menu-variables">
            <LuVariable className={collapsed ? "" : "me-2"} />
            <span className="menu-text">My Variables</span>
          </span>
        )}
      </li>
      <li className="d-none d-md-block">
        {user?.clientId ? (
          <NavLink to="/connector" className="nav-link" title={collapsed ? "My Connectors" : ""} data-tour="menu-connectors">
            <FaDatabase className={collapsed ? "" : "me-2"} />
            <span className="menu-text">My Connectors</span>
          </NavLink>
        ) : (
          <span className="nav-link disabled" style={{ opacity: 0.4, cursor: "not-allowed", color: "rgba(255,255,255,0.5)" }} title="Select a client first" data-tour="menu-connectors">
            <FaDatabase className={collapsed ? "" : "me-2"} />
            <span className="menu-text">My Connectors</span>
          </span>
        )}
      </li>
      {(user?.isSuperUser || user?.isAdmin || user?.isProductTeam) && (
        <>
          <hr />
          <li className="d-none d-md-block">
            <NavLink to="/settings" className="nav-link" title={collapsed ? "Administration" : ""}>
              <AiOutlineSetting className={collapsed ? "" : "me-2"} />
              <span className="menu-text">Administration</span>
            </NavLink>
          </li>
        </>
      )}
      <hr />
      <li>
        <NavLink to="/help" className="nav-link" title={collapsed ? "Help" : ""}>
          <FaQuestionCircle className={collapsed ? "" : "me-2"} />
          <span className="menu-text">Help</span>
        </NavLink>
      </li>
    </>
  );
}

function LeftMenu({ user }) {
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div
      className={`d-none d-md-flex flex-column flex-shrink-0 p-3 text-white bg-dark bg-gradient transition-all ${collapsed ? 'menu-collapsed' : 'menu-expanded'}`}
      style={{
        width: collapsed ? "60px" : "200px",
        transition: "width 0.3s ease",
        height: "calc(100vh - 60px)",
        overflowY: "auto",
        position: "sticky",
        top: 0
      }}
    >
      <div className="d-flex align-items-center justify-content-between mb-3">
        {!collapsed && (
          <span className="fs-5">
            <MdMenuBook className="mb-2 me-3" />
            Menu
          </span>
        )}
        <button
          className="btn btn-link text-white p-0 border-0"
          onClick={toggleCollapse}
          style={{ minWidth: "auto" }}
        >
          {collapsed ? <FaAngleRight size={16} /> : <FaAngleLeft size={16} />}
        </button>
      </div>
      <hr />
      <ul className="nav nav-pills flex-column mb-auto" data-tour="sidebar-menu" style={{ paddingBottom: "2rem" }}>
        <MenuItems user={user} collapsed={collapsed} />
      </ul>
    </div>
  );
}

export default LeftMenu;
